import React, { useState } from 'react';
import axios from 'axios';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/users/forgot-password`, { email });
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>MAtownforms</h1>
          <div style={styles.successBox}>
            <h2 style={styles.successTitle}>Check Your Email</h2>
            <p style={styles.successText}>
              If an account exists for <strong>{email}</strong>, a password reset link has been sent.
              The link expires in 1 hour.
            </p>
            <p style={styles.successHint}>
              <a href="/login" style={styles.anchor}>Back to Sign In</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>MAtownforms</h1>
        <h2 style={styles.subtitle}>Reset Your Password</h2>
        <p style={styles.instructions}>
          Enter your email address and we'll send you a link to reset your password.
        </p>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button style={loading ? styles.buttonDisabled : styles.button} type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        <p style={styles.link}>
          <a href="/login" style={styles.anchor}>Back to Sign In</a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '420px',
  },
  title: {
  color: '#1a3a5c',
  fontSize: '42px',
  fontWeight: '700',
  fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  marginBottom: '8px',
  textAlign: 'center',
},
  subtitle: {
    color: '#444',
    fontSize: '18px',
    marginBottom: '12px',
    textAlign: 'center',
  },
  instructions: {
    fontSize: '14px',
    color: '#666',
    textAlign: 'center',
    marginBottom: '24px',
  },
  field: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '8px',
  },
  buttonDisabled: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#aaa',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'not-allowed',
    marginTop: '8px',
  },
  error: {
    color: '#cc0000',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  successBox: {
    textAlign: 'center',
    padding: '10px 0',
  },
  successTitle: {
    color: '#1a3a5c',
    fontSize: '20px',
    marginBottom: '16px',
  },
  successText: {
    fontSize: '14px',
    color: '#333',
    lineHeight: '1.6',
    marginBottom: '24px',
  },
  successHint: {
    fontSize: '14px',
    color: '#666',
  },
  link: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '14px',
    color: '#555',
  },
  anchor: {
    color: '#1a3a5c',
    fontWeight: '600',
  },
};

export default ForgotPassword;